function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.331 14.372c-.375-1.205-.806-2.217-1.469-3.874.103-4.353-1.706-7.873-5.873-7.873-4.214 0-5.984 3.59-5.872 7.873-.665 1.659-1.094 2.665-1.47 3.874-.796 2.566-.538 3.628-.341 3.651.422.052 1.643-1.93 1.643-1.93 0 1.148.59 2.645 1.87 3.726-.619.19-2.009.7-1.678 1.26.267.453 4.598.289 5.848.148 1.249.141 5.58.305 5.847-.147.33-.558-1.061-1.071-1.678-1.261 1.28-1.083 1.87-2.58 1.87-3.727 0 0 1.222 1.983 1.643 1.931.2-.025.457-1.087-.34-3.651z",
  fill: "currentColor"
});

function SvgQqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgQqIcon;